import React, { useEffect, useState, useRef } from 'react';
import styled from 'styled-components/native';
import { AudioLibrary } from '../hooks/AudioLibrary';
import Ionicons from '@expo/vector-icons/Ionicons';
import {FontAwesome5} from "@expo/vector-icons";

function SongList({callbackFunction, currentlyPlaying}) {
  return (
      <SongListParent>
        <NavContainer
            onPress={() => {
              callbackFunction();
            }}
        >
          <Ionicons name="chevron-back-sharp" size={25} color="#3366cc" />
          <NavText>
            Focused Breathing
          </NavText>
        </NavContainer>
        <HeaderContainer>
          <Waveform
              source={{
                uri: `https://cerebrocoreusa.com/wp-content/plugins/advanced-healthcare-solutions/media/fb_anim.gif`,
              }}
          />

          <HeaderText>
            Audio
          </HeaderText>
        </HeaderContainer>

        <SongFlatList
            data={Object.values(AudioLibrary)}
            keyExtractor={(item, index) => index.toString()}
            renderItem={({item}) => (
                <Song
                    style={{borderBottomWidth:2, borderBottomColor:'#b8daff', width:'100%'}}
                    onPress={() => {
                      //console.log(item, callbackFunction);
                      callbackFunction(item);
                    }}
                >
                  <SongText>
                    {item.name}
                  </SongText>

                  { item.name === currentlyPlaying && (
                      <FontAwesome5 name="check" size={18} color="#c4579d" />
                  )}
                </Song>
            )}
        />

      </SongListParent>
  );
}

export const SongListParent = styled.View`
    width:100%;
    height:100%;
    background:white;
    z-index:999;
    display:flex;
    justify-content:center;
    align-items:center;

`

export const HeaderContainer = styled.View`
    width:85%;
    max-width:500px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    flex-direction:row;
    margin-top:20px;
    margin-bottom:20px;
`

export const NavContainer = styled.TouchableOpacity`
    width:100%;
    max-width:500px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
    flex-direction:row;
    margin-top:20px;
    margin-bottom:20px;
    padding-left:12.5px;
`

export const NavText = styled.Text`

    font-size:20px;
    font-family:'Montserrat-SB';
    color:#272f63;
    margin-left:15px;

`

export const HeaderText = styled.Text`
    font-size:18px;
    font-family:'Montserrat-SB';
    color:#c4579d;
`

export const Waveform = styled.Image`
    height:75px;
    width:40px;
    margin-right:15px;
`

export const SongFlatList = styled.FlatList`
    width:85%;
    max-width:500px;
`

export const Song = styled.TouchableOpacity`
    height: 50px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-right:15px;
`

export const SongText = styled.Text`
    margin-left:10px;
    font-size:16px;
    font-family:'Montserrat-SB';
    color:#272f63;
    flex: 1; 
`



export default SongList;
